import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'bp-svg-admin-shared-icons-definitions',
	templateUrl: './svg-admin-shared-icons-definitions.component.html',
	styles: [ ':host { display: none }' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgAdminSharedIconsDefinitionsComponent { }
